import { render } from "./VacancyHistoryCard.vue?vue&type=template&id=f1f2eff4&scoped=true"
import script from "./VacancyHistoryCard.vue?vue&type=script&lang=js"
export * from "./VacancyHistoryCard.vue?vue&type=script&lang=js"

import "./VacancyHistoryCard.vue?vue&type=style&index=0&id=f1f2eff4&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f2eff4"]])

export default __exports__